module.exports = __webpack_public_path__ + "img/img2.7c0f3603.svg";